'use client';

import { useEffect, useState } from 'react';

const QUERY = '(min-width: 768px)';

export const useIsMdUp = (): boolean => {
  const [isMdUp, setIsMdUp] = useState(true);
  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return;
    }
    const mql = window.matchMedia(QUERY);
    const update = () => setIsMdUp(mql.matches);
    update();
    mql.addEventListener('change', update);
    return () => mql.removeEventListener('change', update);
  }, []);
  return isMdUp;
};
